module.exports = __webpack_public_path__ + "static/media/graph_body_red.91e84a8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/graph_body_red.png
// module id = 1632
// module chunks = 1